import { z } from 'zod';
import { FOB_POINT_CONSTRAINTS } from './constraints.js';
export const updateFobPointInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${FOB_POINT_CONSTRAINTS.name.label} cannot be empty.`)
        .max(FOB_POINT_CONSTRAINTS.name.maxLength)
        .optional(),
});
//# sourceMappingURL=update-input.js.map